import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useSelector,useDispatch } from "react-redux";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import Accordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useTranslation } from "react-i18next";
import { faqApiLoading } from "../../../model/action";
import { commonService } from "../../../../../services/common.service";
import i18next from "i18next";
const useStyles = makeStyles((theme) => ({
  container: {
    height: "25rem",
  },
  errroIcon: {
    width: "10em",
    height: "auto",
    margin: "2em auto",
    display: "block",
    color: theme.palette.eLight.base,
  },
  errorText: {
    textAlign: "center",
  },
  viewAll: {
    textAlign: "center",
    color: theme.palette.ePrimary.base,
    margin: "1em auto",
    cursor: "pointer",
  },
  faqGrid: {
    [theme.breakpoints.up("xs")]: {
      marginTop: "5%",
      marginLeft: "5%",
      width: "90%",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "2%",
      marginLeft: "2.5%",
      width: "95%",
    },
    "&:last-child": {
      marginBottom: "5%",
    },
  },
  faqTitle: {
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  mobileHeading: {
    color: theme.palette.ePrimary.base,
    textAlign: "center",
    paddingTop:'0.5rem'
  },
}));

const AccordionSummary = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eLight.base,
    minHeight: "auto",
    "&$expanded": {
      minHeight: 40,
    },
  },
  content: {
    margin: "0% 0%",
    width: "80%",
    "&$expanded": {
      margin: "0% 0%",
    },
  },
  expanded: {
    height: "auto",
  },
}))(MuiAccordionSummary);

function EFaqs({ getFaqData, searchFAQData, keyWord }) {
  const dispatch = useDispatch()
  const classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const {t:labels, ready: labelReady} = useTranslation("label-E_AUTH_LOGIN");
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const [initialFaq, setInitialFaq] = useState([]);
  const [allFaq, setAllFaq] = useState([]);
  const [faqs, setFaq] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [viewAllToggle, setViewAllToggle] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [length,setLength]=useState(0);
  const { z: content } = useTranslation("content-FAQ_AUTH")

  const RECORD_LIMIT = 6;
  const { i18n } = useTranslation();
  const [faqData, setFaqData] = useState(null);
  let faqArray = [];
  let i18nObject = i18n.store.getResourceBundle(i18next.language,"content-FAQ_AUTH");
  useEffect(() => {
          if (i18nObject && Object.values(i18nObject).length) {
            Object.keys(i18nObject).forEach(key => {
              faqArray.push(i18nObject[key]);
            });
            setFaqData(faqArray);
          }
  }, [i18nObject,i18next.language]);
  useEffect(() => {
    setFaq([]);
    setInitialFaq([]);
    if (keyWord === undefined) {
        dispatch(faqApiLoading(true))
        setLoading(true);
            setInitialFaq(
              faqData?.slice(0, RECORD_LIMIT)
            );
            setAllFaq(faqData);
            setFaq(
              faqData?.slice(0, RECORD_LIMIT)
            );
            setLoading(false);
            setIsError(false);
            dispatch(faqApiLoading(false))
    } else {
      if (searchFAQData) {
        setInitialFaq(searchFAQData?.slice(0, RECORD_LIMIT));
        setAllFaq(searchFAQData);
        setFaq(searchFAQData?.slice(0, RECORD_LIMIT));
      }
    }
  }, [ keyWord, searchFAQData,faqData]);
  useEffect(() => {
    if (viewAllToggle) setFaq(allFaq);
    else setFaq(initialFaq);
  }, [viewAllToggle,initialFaq,allFaq]);
  const {t:label, ready: labelsReady}=useTranslation("label-E_SELF_HELP")
  const [contactPDFPath, setContactPDFPath] = useState("");
 const [contactOSSPDFPath, setContactOSSPDFPath] = useState("");
 const contactPDF = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_NESCO_PDF);
 const contactOSSPDF = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_NESCO_PDF_OSS);
 useEffect(() => {
  if (contactPDF) {
    commonService.getAssestUrl(contactPDF).then((response) => {
      setContactPDFPath(response);
  }) 
}
if (contactOSSPDF) {
  commonService.getAssestUrl(contactOSSPDF).then((response) => {
    setContactOSSPDFPath(response);
})
}
},[contactPDF,contactOSSPDF]);
useEffect(()=>{
  if(i18next.language=='bn')setLength(allFaq?.length+2)
  if(i18next.language=='en')setLength(allFaq?.length)
},[allFaq,i18next.language])
  return (
    <>
      {loading && (
        <>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
        </>
      )}
      {isError && (
        <>
          <ReportProblemOutlinedIcon className={classes.errroIcon} />
          {
            labelReady?
          <Typography className={classes.errorText}>
            {labels("E_ERROR_MESSAGE")}
          </Typography>
          : <Skeleton />
          }
        </>
      )}
      {(length && !isError) || !loading ? (
        <>
          {isTabletOrMobile && (
            <Typography
              variant="h3"
              class={classes.mobileHeading}
              align="center"
            >
              {labelReady ? labels("E_FAQ_MOBILE_HEADING") : <Skeleton />}
            </Typography>
          )}
          <div
            className={classes.container}
            style={{
              overflowY:
                viewAllToggle || expanded !== null
                  ? browserName === "firefox"
                    ? "auto"
                    : "overlay"
                  : "hidden",
            }}
          >
            {faqs?.map((faq, key) => {
              return (
                <div className={classes.faqGrid} item xs={12}>
                  <Accordion
                    expanded={key == expanded}
                    onClick={(e) => {
                      if (expanded == key) setExpanded(null);
                      else setExpanded(key);
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography
                        noWrap={expanded != key}
                        className={classes.faqTitle}
                        variant="subtitle2"
                      >
                        {faq?.question
                          ? faq.question
                          : faq?._source?.ContentTitle}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        variant="subtitle2"
                        dangerouslySetInnerHTML={{
                          __html: faq?.answer
                            ? faq.answer
                            : faq?._source?.ContentValue,
                        }}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            })}
            {searchFAQData ? null  : (<>
              <div className={classes.faqGrid} item xs={12}>
                        <Accordion
                          onClick={(e) => {
                            if (expanded == faqs.length) setExpanded(null);
                            else setExpanded(faqs.length);
                          }}
                        >
                        <AccordionSummary 
                         expandIcon={<ExpandMoreIcon />}
                         aria-controls="panel1a-content">
                          {labelsReady ?  
                          <Typography
                        className={classes.faqTitle}
                        variant="subtitle2"
                      >{label("E_OFFICE_LOCAL_OFFICE")}</Typography>   : <><Skeleton/></>}
                        </AccordionSummary>
                        <AccordionDetails><span><a target="_blank" href={labels("E_OFFICES_URL")} >{labelsReady ? label("E_OFFICE_OSS_PDF") : <><Skeleton/></>}</a></span></AccordionDetails>
                      </Accordion>
                        </div>
                        {/* <div className={classes.faqGrid} item xs={12}>
                        <Accordion
                          onClick={(e) => {
                            if (expanded == (faqs.length+1)) setExpanded(null);
                            else setExpanded(faqs.length+1);
                          }}
                        >
                          <AccordionSummary 
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content">{labelsReady ?  
                          <Typography
                            className={classes.faqTitle}
                            variant="subtitle2">
                              {label("E_OFFICE_COMPLAINT")}</Typography> : <><Skeleton/></>}</AccordionSummary>
                          <AccordionDetails><span><a target="_blank" href={contactPDFPath?.assetPath} >{labelsReady ? label("E_OFFICE_PDF") : <><Skeleton/></>}</a></span></AccordionDetails>
                        </Accordion></div> */}
          </>)}
          </div>
          {length > RECORD_LIMIT && labelReady ? (
            <Typography
              variant="subtitle2"
              className={classes.viewAll}
              onClick={(e) => {
                setViewAllToggle(!viewAllToggle);
              }}
            >
              {!viewAllToggle ? labels("E_VIEW_ALL") : labels("E_VIEW_LESS")}
            </Typography>
          ) : null}
        </>
      ) : !loading && (        <>
        <ReportProblemOutlinedIcon className={classes.errroIcon} />
        {
          labelReady ?
        <Typography className={classes.errorText}>
          {labels("E_NO_RECORDS_FOUND_MESSAGE")}
        </Typography>
        : <Skeleton />
        }
      </>)}
    </>
  );
}

export default EFaqs;
